import vTransition from '@/components/v-transition'
import vlayout from '@/components/v-layout'
import vNavbar from '@/components/v-navbar'
import Message from './Message/index.js'
import Modal from './modal/index.js'
import musicPlay from './musicPlay/index.js'
 
//批量安装全局使用组件
const components = {
  vTransition,vlayout,vNavbar,Modal,Message,musicPlay
}
const install = function(Vue, opts = {}) {    
       Object.keys(components).forEach((key) => {        
        Vue.component(key, components[key]);    
    })
    Vue.prototype.$Message = Message;
    Vue.prototype.$Modal = Modal;
    Vue.prototype.$Play = musicPlay;
}
export default install


 




// WEBPACK FOOTER //
// ./src/components/publicUi.js